// ALERTS ***************************************************************************************
export const ALERT_ADD = 'ALERT_ADD'
export const ALERT_REMOVE = 'ALERT_REMOVE'

// PROJECTS ***********************************************************************************
export const PROJECT_GET_ALL_REQUEST = 'PROJECT_GET_ALL_REQUEST'
export const PROJECT_GET_ALL_SUCCESS = 'PROJECT_GET_ALL_SUCCESS'
export const PROJECT_GET_ALL_FAIL = 'PROJECT_GET_ALL_FAIL'

// EXPERIENCE *********************************************************************************
export const EXPERIENCE_GET_ALL_REQUEST = 'EXPERIENCE_GET_ALL_REQUEST'
export const EXPERIENCE_GET_ALL_SUCCESS = 'EXPERIENCE_GET_ALL_SUCCESS'
export const EXPERIENCE_GET_ALL_FAIL = 'EXPERIENCE_GET_ALL_FAIL'

// SKILLS *********************************************************************************
export const SKILL_GET_ALL_REQUEST = 'SKILL_GET_ALL_REQUEST'
export const SKILL_GET_ALL_SUCCESS = 'SKILL_GET_ALL_SUCCESS'
export const SKILL_GET_ALL_FAIL = 'SKILL_GET_ALL_FAIL'

// MESSAGES ********************************************************************************
export const MESSAGE_SEND_REQUEST = 'MESSAGE_SEND_REQUEST'
export const MESSAGE_SEND_SUCCESS = 'MESSAGE_SEND_SUCCESS'
export const MESSAGE_SEND_FAIL = 'MESSAGE_SEND_FAIL'

// RESUME ************************************************************************************
export const RESUME_GET_LINK_REQUEST = 'RESUME_GET_LINK_REQUEST'
export const RESUME_GET_LINK_SUCCESS = 'RESUME_GET_LINK_SUCCESS'
export const RESUME_GET_LINK_FAIL = 'RESUME_GET_LINK_FAIL'
